import React, { useEffect, useState } from "react";
import { downloadAPK } from "../../Helpers/DownloadAPK";
import "./AppInstallPopup.css";

const AppInstallPopup = () => {
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState("install");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      const timer = setTimeout(() => {
        setShow(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleDownload = async () => {
    try {
      setStatus("downloading");
      setProgress(0);

      // Trigger direct APK download on current page - NO redirect, NO new tab!
      downloadAPK();

      let current = 0;
      const interval = setInterval(() => {
        // Smooth progressive increment
        const increment = Math.floor(Math.random() * 6) + 3;
        current += increment;

        if (current >= 100) {
          current = 100;
          clearInterval(interval);
          setProgress(100);

          setTimeout(() => {
            setStatus("completed");
          }, 350);

          // Auto-close after 3.5 seconds
          setTimeout(() => {
            setShow(false);
          }, 3800);

          return;
        }

        setProgress(current);
      }, 75);
    } catch (err) {
      console.error(err);
      downloadAPK();
    }
  };

  if (!show) return null;

  return (
    <div className="apk-overlay">
      <div className="apk-popup">
        <button
          className="apk-close"
          onClick={() => setShow(false)}
        >
          ✕
        </button>

        <div className="apk-dragger"></div>

        <div className="apk-header">
          {/* <img
            src="/logo.png"
            alt="logo"
            className="apk-logo"
          /> */}

          <p className="apk-app-name">
            K
          </p>

          <div>
            <p className="apk-app-type">Android App</p>

            <h3 className="apk-title">
              Khatri555 App
            </h3>

            <p className="apk-subtitle">
              Official Download
            </p>
          </div>
        </div>

        <div className="apk-stats">
          <div>
            <strong>4.9 ★</strong>
            <span>777 Reviews</span>
          </div>

          <div>
            <strong>100K+</strong>
            <span>Downloads</span>
          </div>

          <div>
            <strong>18+</strong>
            <span>Rated</span>
          </div>
        </div>

        {status === "install" && (
          <button
            className="install-btn"
            onClick={handleDownload}
          >
            Install Now
          </button>
        )}

        {status === "downloading" && (
          <div className="download-box">
            <div className="download-row">
              <span className="download-step-title">
                {progress < 25
                  ? "Connecting to secure server..."
                  : progress < 75
                  ? "Downloading Khatri555 APK..."
                  : progress < 100
                  ? "Verifying package..."
                  : "Download Complete!"}
              </span>
              <span className="download-pct">{progress}%</span>
            </div>

            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{
                  width: `${progress}%`,
                }}
              />
            </div>

            <div className="download-sub-row">
              <span>{((progress / 100) * 18.4).toFixed(1)} MB / 18.4 MB</span>
              <span>{progress < 100 ? "4.2 MB/s" : "Done"}</span>
            </div>
          </div>
        )}

        {status === "completed" && (
          <div className="download-box download-complete-box">
            <div className="success-circle">
              ✓
            </div>

            <div className="download-success">
              APK Downloaded!
            </div>

            <div className="download-msg success">
              Check notifications or Downloads folder to install.
            </div>

            <button
              className="install-btn done-btn"
              onClick={() => setShow(false)}
            >
              Done
            </button>
          </div>
        )}

        <div className="about-app">
          <h4>About this app</h4>

          <p>
            Get live results, charts and fast updates
            in one secure app.
          </p>

          <div className="tags">
            <span>Live Results</span>
            <span>Charts</span>
            <span>Fast Updates</span>
          </div>
        </div>

        <button
          className="not-now"
          onClick={() => setShow(false)}
        >
          Not now
        </button>
      </div>
    </div>
  );
};

export default AppInstallPopup;